import { render, staticRenderFns } from "./Chakras.vue?vue&type=template&id=3cb6f7dd&scoped=true&"
import script from "./Chakras.vue?vue&type=script&lang=js&"
export * from "./Chakras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb6f7dd",
  null
  
)

export default component.exports